module.exports = __webpack_public_path__ + "static/media/26UNRWA14.aca0292a.jpg";